/**
 * sk-plant-qm.js — Pflanzen-Mengen-View (snippets/sk-plant-qty-matrix.liquid, NUR templates/product.pflanze.json)
 * 1) Mengen-Stepper je Größe, Summe, „reicht für ca. X m Hecke", Mengenrabatt-Anzeige (Metafeld pflanze.staffel)
 * 2) Ein Klick: alle Größen mit Menge > 0 (+ optional Dünger) gemeinsam per POST /cart/add.js {items:[…]}
 * 3) Heckenrechner (sections/sk-plant-hedge): „Übernehmen" schreibt die Stückzahl in die passende Zeile;
 *    ohne Mengen-View legt der Button direkt in den Warenkorb – beides mit Inline-Fehlern (422/429/Netz),
 *    niemals nativer Form-Fallback auf Shopifys Fehlerseite.
 * 4) Aktive Zeile → Empire <variant-selection> (Preis-Block, ?variant= in der URL, Lieferblock via sk-plant.js)
 * 5) Lieferform-Reiter (13.10.2026): Reiter filtern die Zeilen, Mengen in anderen Reitern bleiben erhalten (Zähler am
 *    Reiter + „Außerdem gewählt"), Tastatur ←/→/Pos1/Ende; Ereignisse „sk-plant:variant" / „sk-plant:tab" für
 *    sk-plant.js (Icon-Steckbrief, Lieferblock) und den Heckenrechner – auch in der Entwurfs-Vorschau ohne Empire-Daten.
 * 6) Zubehör „für N Pflanzen": Menge = ⌈N / Pflanzen je Packung⌉, angehakt → mit in den Warenkorb.
 * 7) Lieferzeit/Versandart je Größe → localStorage „sk_plant_ship_v1" (Warenkorb-Drawer, assets/sk-drawer.js).
 * 8) Auswahl inkl. SKU/Gewicht/Versandklasse → Ereignis „sk-plant:qm-lines" für den Frachtkasten (assets/sk-plant-freight.js).
 * 9) UX-Umbau 21.10.2026: Heckenrechner als Aufklapper an der Größenliste – Buttons [data-sk-hedge-take] tragen die Stückzahl
 *    in die Zeile ein; „Alle N anzeigen“ zählt je Reiter (data-tpl) und verschwindet, wenn der Reiter ≤ 4 Größen hat.
 * Kein Framework. Andere Produkte laden diese Datei nicht.
 */
(function () {
  'use strict';
  if (window.__skPlantQmInit) return;
  window.__skPlantQmInit = true;

  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function readJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  /* Der Liquid-Filter „t" gibt HTML-escaped aus (&#39; &amp; …) → für textContent dekodieren */
  var decoder = document.createElement('textarea');
  function decodeAll(obj) {
    if (!obj) return {};
    Object.keys(obj).forEach(function (k) {
      if (typeof obj[k] === 'string' && obj[k].indexOf('&') > -1) { decoder.innerHTML = obj[k]; obj[k] = decoder.value; }
    });
    return obj;
  }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fill(str, map) {
    return String(str || '').replace(/%([A-Z]+)%/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }

  /* ---------- Warenkorb (gemeinsam für Mengen-View und Heckenrechner) ---------- */
  function addItems(items) {
    return fetch(ROOT_URL + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) {
          var err = new Error('cart-add ' + r.status);
          err.status = r.status;
          err.description = data && (data.description || data.message);
          throw err;
        }
        return data;
      });
    }).then(function (added) {
      return fetch(ROOT_URL + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (cart) {
          if (cart) window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
          return { added: added, cart: cart };
        });
    });
  }

  function errorText(err, i18n) {
    if (!err || err.status == null) return i18n.error_network;
    if (err.status === 429) return i18n.error_rate;
    if (err.status === 422 && err.description) return String(err.description);
    return i18n.error_generic;
  }

  function openDrawer() {
    if (window.skDrawer && typeof window.skDrawer.open === 'function') {
      try { window.skDrawer.open(); return true; } catch (e) { /* Drawer optional */ }
    }
    return false;
  }

  /* ---------- Mengen-View ---------- */
  function Matrix(root) {
    this.root = root;
    this.form = $('[data-sk-qm-form]', root);
    this.i18n = decodeAll(readJSON($('[data-sk-qm-i18n]', root)));
    this.staffel = readJSON($('[data-sk-qm-staffel]', root));
    this.locale = (root.getAttribute('data-locale') || document.documentElement.lang || 'de').replace('_', '-');
    this.currency = root.getAttribute('data-currency') || 'EUR';
    this.isHedge = root.getAttribute('data-hedge') === 'true';
    this.sectionId = root.getAttribute('data-section-id') || '';
    try { this.plural = new Intl.PluralRules(this.locale); } catch (e) { this.plural = new Intl.PluralRules('de'); }
    try {
      this.fmt = new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.currency });
    } catch (e) {
      this.fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
    }
    this.rows = $$('[data-sk-qm-row]', root).map(function (el) {
      return {
        el: el,
        id: el.getAttribute('data-variant-id'),
        price: parseInt(el.getAttribute('data-price'), 10) || 0,
        spm: parseFloat(el.getAttribute('data-spm')) || 0,
        max: Math.max(0, Math.min(999, parseInt(el.getAttribute('data-max'), 10) || 0)),
        size: el.getAttribute('data-size') || '',
        sku: el.getAttribute('data-sku') || '',
        grams: parseInt(el.getAttribute('data-grams'), 10) || 0,
        ship: el.getAttribute('data-cart-ship') || '',
        tab: el.hasAttribute('data-tab') ? parseInt(el.getAttribute('data-tab'), 10) : -1,
        avail: !!$('[data-sk-qm-qty]', el),
        input: $('[data-sk-qm-qty]', el),
        minus: $('[data-sk-qm-step="-1"]', el),
        plus: $('[data-sk-qm-step="1"]', el)
      };
    });
    this.addon = $('[data-sk-qm-addon]', root);
    this.tabs = $$('[data-sk-qm-tab]', root);
    this.panel = $('.sk-plant-qm__panel', root);
    this.elsewhere = $('[data-sk-qm-elsewhere]', root);
    this.activeTab = 0;
    var self0 = this;
    this.tabs.forEach(function (t, i) { if (t.getAttribute('aria-selected') === 'true') self0.activeTab = i; });
    this.acc = $$('[data-sk-qm-acc-row]', root).map(function (el) {
      return {
        el: el,
        id: el.getAttribute('data-variant-id'),
        price: parseInt(el.getAttribute('data-price'), 10) || 0,
        pro: parseFloat(el.getAttribute('data-pro')) || 0,
        title: el.getAttribute('data-title') || '',
        check: $('[data-sk-qm-acc-check]', el),
        nEl: $('[data-sk-qm-acc-n]', el),
        n: 1
      };
    });
    this.accTitle = $('[data-sk-qm-acc-title]', root);
    this.btn = $('[data-sk-qm-atc]', root);
    this.errEl = $('[data-sk-qm-error]', root);
    this.okEl = $('[data-sk-qm-ok]', root);
    this.liveEl = $('[data-sk-qm-live]', root);
    this.btnText = $('[data-sk-qm-atc-text]', root);
    this.bar = $('[data-sk-qm-bar]', root);
    this.atcVisible = true;
    this.liveTimer = 0;
    this.syncTimer = 0;
    this.bind();
    this.bindTabs();
    this.initBar();
    this.update(false);
    this.saveShip();
  }

  /* ---------- Lieferform-Reiter ---------- */
  Matrix.prototype.bindTabs = function () {
    var self = this;
    if (!this.tabs.length) return;
    this.tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { self.activate(i, true); });
      tab.addEventListener('keydown', function (e) {
        var n = self.tabs.length;
        var to = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') to = (i + 1) % n;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') to = (i - 1 + n) % n;
        else if (e.key === 'Home') to = 0;
        else if (e.key === 'End') to = n - 1;
        if (to < 0) return;
        e.preventDefault();
        self.activate(to, true);
        self.tabs[to].focus();
      });
    });
    if (this.elsewhere) {
      this.elsewhere.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sk-qm-goto]');
        if (!b) return;
        var i = parseInt(b.getAttribute('data-sk-qm-goto'), 10) || 0;
        self.activate(i, true);
        if (self.tabs[i]) self.tabs[i].focus();
      });
    }
  };

  Matrix.prototype.activate = function (i, user) {
    var self = this;
    if (!this.tabs.length || i < 0 || i >= this.tabs.length) return;
    this.activeTab = i;
    this.tabs.forEach(function (t, k) {
      var on = k === i;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
    });
    if (this.panel) this.panel.setAttribute('aria-labelledby', this.tabs[i].id);
    this.rows.forEach(function (r) { r.el.classList.toggle('is-off', r.tab !== i); });
    this.moreLabel();
    this.update(false);
    document.dispatchEvent(new CustomEvent('sk-plant:tab', { detail: { index: i, label: this.tabs[i].getAttribute('data-label') || '' } }));
    if (user) {
      // gewählte Größe des Reiters (sonst erste lieferbare) → Preis, Lieferblock, Icon-Steckbrief
      var pick = null;
      this.rows.some(function (r) { if (r.tab === i && self.qty(r) > 0) { pick = r; return true; } return false; });
      if (!pick) this.rows.some(function (r) { if (r.tab === i && r.avail) { pick = r; return true; } return false; });
      if (!pick) this.rows.some(function (r) { if (r.tab === i) { pick = r; return true; } return false; });
      if (pick) this.syncVariant(pick.id);
    }
  };

  /* ---------- Lieferzeit je Größe für den Warenkorb-Drawer (sk-drawer.js liest „sk_plant_ship_v1") ---------- */
  Matrix.prototype.saveShip = function () {
    var KEY = 'sk_plant_ship_v1';
    var now = Date.now();
    var data;
    try { data = JSON.parse(window.localStorage.getItem(KEY) || 'null'); } catch (e) { data = null; }
    if (!data || typeof data !== 'object' || !data.v) data = { v: {} };
    var i18n = this.i18n;
    data.l = { note: i18n.cart_note || '', sped: i18n.cart_sped || '', lang: this.locale };
    this.rows.forEach(function (r) {
      var t = r.el.getAttribute('data-cart-time') || '';
      var sh = r.el.getAttribute('data-cart-ship') || '';
      var va = r.el.getAttribute('data-cart-vab') || '';
      if (!t && !sh && !va) return;
      data.v[r.id] = { t: t, s: sh, a: va, k: t + '|' + sh + '|' + va, ts: now };
    });
    // aufräumen: älter als 21 Tage raus, höchstens 400 Einträge
    var ids = Object.keys(data.v).filter(function (id) { return now - (data.v[id].ts || 0) < 21 * 864e5; });
    ids.sort(function (a, b) { return (data.v[b].ts || 0) - (data.v[a].ts || 0); });
    var keep = {};
    ids.slice(0, 400).forEach(function (id) { keep[id] = data.v[id]; });
    data.v = keep;
    try { window.localStorage.setItem(KEY, JSON.stringify(data)); } catch (e) { /* Speicher voll/gesperrt */ }
  };

  /* Mobile Summenleiste: nur < 768 px, nur mit Menge > 0, nur wenn Button und Summe außer Sicht sind */
  Matrix.prototype.initBar = function () {
    var self = this;
    if (!this.bar) return;
    this.mq = window.matchMedia('(max-width: 767.98px)');
    var seen = new Map();
    if ('IntersectionObserver' in window && this.btn) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { seen.set(en.target, en.isIntersecting); });
        var any = false;
        seen.forEach(function (v) { if (v) any = true; });
        self.atcVisible = any;
        self.toggleBar();
      }, { threshold: 0 });
      io.observe(this.btn);
      var sum = $('[data-sk-qm-sum]', this.root);
      if (sum) io.observe(sum);
    }
    var barBtn = $('[data-sk-qm-bar-btn]', this.bar);
    if (barBtn) barBtn.addEventListener('click', function () { self.submit(true); });
    if (this.mq.addEventListener) this.mq.addEventListener('change', function () { self.toggleBar(); });
  };

  Matrix.prototype.toggleBar = function () {
    if (!this.bar || !this.mq) return;
    var show = !!(this.mq.matches && this.count > 0 && !this.atcVisible);
    if (this.bar.hidden === !show) return;
    this.bar.hidden = !show;
    document.documentElement.classList.toggle('sk-qm-bar-on', show);
  };

  Matrix.prototype.pl = function (key, n) {
    var cat = this.plural.select(n);
    var s = this.i18n[key + '_' + cat] || this.i18n[key + '_other'] || '';
    return fill(s, { N: String(n) });
  };

  Matrix.prototype.money = function (cents) { return this.fmt.format(cents / 100); };

  Matrix.prototype.num = function (n) {
    var r = Math.round(n * 10) / 10;
    var s = r % 1 === 0 ? String(r) : r.toFixed(1);
    return s.replace('.', this.i18n.decimal || ',');
  };

  Matrix.prototype.qty = function (row) {
    if (!row.input) return 0;
    var n = parseInt(String(row.input.value).replace(/[^0-9]/g, ''), 10);
    if (!isFinite(n) || n < 0) n = 0;
    return Math.min(n, row.max);
  };

  Matrix.prototype.setQty = function (row, n, announceMax) {
    if (!row.input) return;
    var clamped = Math.max(0, Math.min(row.max, n | 0));
    row.input.value = String(clamped);
    if (announceMax && n > row.max) this.say(fill(this.i18n.max, { N: String(row.max) }));
  };

  Matrix.prototype.rowById = function (id) {
    for (var i = 0; i < this.rows.length; i++) if (this.rows[i].id === String(id)) return this.rows[i];
    return null;
  };

  Matrix.prototype.bind = function () {
    var self = this;
    this.rows.forEach(function (row) {
      // 29.10.2026: Klick auf die Zeile (außerhalb von Stepper/Links) wählt die Größe → Bild + ?variant= (sk-plant.js)
      if (row.id) {
        row.el.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('button, input, a, label, select, summary')) return;
          self.syncVariant(row.id);
        });
      }
      if (!row.input) return;
      [row.minus, row.plus].forEach(function (b) {
        if (!b) return;
        b.addEventListener('click', function () {
          var step = parseInt(b.getAttribute('data-sk-qm-step'), 10) || 0;
          self.setQty(row, self.qty(row) + step, step > 0);
          self.touched(row);
        });
      });
      row.input.addEventListener('input', function () { self.touched(row, true); });
      row.input.addEventListener('change', function () {
        var raw = parseInt(String(row.input.value).replace(/[^0-9]/g, ''), 10) || 0;
        self.setQty(row, raw, true);
        self.touched(row);
      });
      row.input.addEventListener('focus', function () { try { row.input.select(); } catch (e) { /* iOS */ } });
    });
    if (this.addon) this.addon.addEventListener('change', function () { self.update(true); });
    this.acc.forEach(function (a) { if (a.check) a.check.addEventListener('change', function () { self.update(true); }); });
    var more = $('[data-sk-qm-more]', this.root);
    this.more = more;
    if (more) {
      more.addEventListener('click', function () {
        var open = !self.root.classList.contains('sk-plant-qm--all');
        self.root.classList.toggle('sk-plant-qm--all', open);
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        self.moreLabel();
      });
      this.moreLabel();
    }
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.submit();
    });
  };

  /* „Alle N anzeigen“: Anzahl der Größen im sichtbaren Reiter; ohne ausgeblendete Größen im Reiter kein Button */
  Matrix.prototype.moreLabel = function () {
    var more = this.more;
    if (!more) return;
    var self = this;
    var inTab = this.rows.filter(function (r) { return !self.tabs.length || r.tab === self.activeTab; });
    var hasExtra = inTab.some(function (r) { return r.el.classList.contains('is-extra'); });
    more.hidden = !hasExtra;
    var open = this.root.classList.contains('sk-plant-qm--all');
    var tpl = more.getAttribute('data-tpl') || '';
    more.textContent = open ? more.getAttribute('data-less') : (tpl ? fill(tpl, { N: String(inTab.length) }) : more.textContent);
  };

  Matrix.prototype.touched = function (row, typing) {
    this.hideMessages();
    var mark = $('[data-sk-qm-added]', row.el);
    if (mark) mark.hidden = true;
    this.update(true, typing);
    if (this.qty(row) > 0) this.syncVariant(row.id);
  };

  /* Aktive Größe an Empire melden → Preis-Block, ?variant=, Lieferblock (sk-plant.js), Markierung im Heckenrechner */
  Matrix.prototype.syncVariant = function (id) {
    var self = this;
    // sofort: Icon-Steckbrief/Lieferblock (sk-plant.js) – funktioniert auch ohne Empire-Produktdaten (Entwurfs-Vorschau)
    var r0 = this.rowById(id);
    document.dispatchEvent(new CustomEvent('sk-plant:variant', {
      detail: { id: String(id), price: r0 ? r0.price : null, priceText: r0 ? this.money(r0.price) : '', sectionId: this.sectionId }
    }));
    window.clearTimeout(this.syncTimer);
    this.syncTimer = window.setTimeout(function () {
      var scope = self.sectionId ? document.getElementById('shopify-section-' + self.sectionId) : document;
      var vs = scope && scope.querySelector('variant-selection');
      if (!vs || vs.getAttribute('variant') === String(id)) return;
      // Nur wenn Empire die Produktdaten laden konnte (Entwurfs-Vorschau: /products/….js = 404 → sonst leeres ?variant=)
      var ready = typeof vs.getProduct === 'function' ? vs.getProduct() : Promise.resolve(null);
      ready.then(function (product) {
        if (product && product.variants && product.variants.some(function (v) { return String(v.id) === String(id); })) {
          vs.setAttribute('variant', String(id));
        }
      }).catch(function () { /* ohne Sync weiter */ });
    }, 200);
  };

  Matrix.prototype.discount = function (lines, count) {
    var st = this.staffel;
    var res = { pct: 0, cents: 0, next: null };
    if (!st || !st.stufen || !st.stufen.length) return res;
    var tiers = st.stufen.filter(function (t) { return t && t.ab >= 2 && t.prozent > 0 && t.prozent < 50; })
      .sort(function (a, b) { return a.ab - b.ab; });
    if (!tiers.length) return res;
    function best(n) {
      var p = 0;
      tiers.forEach(function (t) { if (n >= t.ab) p = t.prozent; });
      return p;
    }
    if (st.basis === 'variante') {
      var maxQ = 0;
      lines.forEach(function (l) {
        var p = best(l.q);
        if (p > res.pct) res.pct = p;
        res.cents += Math.round((l.price * l.q * p) / 100);
        if (l.q > maxQ) maxQ = l.q;
      });
      tiers.some(function (t) { if (maxQ < t.ab) { res.next = { missing: t.ab - maxQ, pct: t.prozent }; return true; } return false; });
    } else {
      res.pct = best(count);
      var sum = 0;
      lines.forEach(function (l) { sum += l.price * l.q; });
      res.cents = Math.round((sum * res.pct) / 100);
      tiers.some(function (t) { if (count < t.ab) { res.next = { missing: t.ab - count, pct: t.prozent }; return true; } return false; });
    }
    return res;
  };

  Matrix.prototype.update = function (announce, typing) {
    var self = this;
    var lines = [];
    var count = 0;
    var total = 0;
    var meters = 0;
    var metersOk = this.isHedge;
    this.rows.forEach(function (row) {
      var q = self.qty(row);
      row.el.classList.toggle('is-picked', q > 0);
      if (row.minus) row.minus.disabled = q <= 0;
      if (row.plus) row.plus.disabled = q >= row.max;
      if (q > 0) {
        var tabLabel = row.tab >= 0 && self.tabs[row.tab] ? self.tabs[row.tab].getAttribute('data-label') : '';
        lines.push({ id: row.id, q: q, price: row.price, size: tabLabel ? tabLabel + ' ' + row.size : row.size, sku: row.sku, grams: row.grams, ship: row.ship });
        count += q;
        total += q * row.price;
        if (row.spm > 0) meters += q / row.spm; else metersOk = false;
      }
    });
    var addonOn = !!(this.addon && this.addon.checked && count > 0);
    var addonCents = addonOn ? parseInt(this.addon.getAttribute('data-price'), 10) || 0 : 0;
    // Zubehör „für N Pflanzen"
    var basis = count > 0 ? count : 1;
    this.acc.forEach(function (a) {
      a.n = a.pro > 0 ? Math.max(1, Math.ceil(basis / a.pro)) : 1;
      if (a.nEl) a.nEl.textContent = String(a.n);
      a.el.classList.toggle('is-checked', !!(a.check && a.check.checked));
      if (a.check && a.check.checked && count > 0) addonCents += a.n * a.price;
    });
    if (this.accTitle) this.accTitle.textContent = basis === 1 ? (this.i18n.acc_one || '') : fill(this.i18n.acc_other, { N: String(basis) });
    // Reiter: Zähler je Reiter + Hinweis auf Mengen in anderen Reitern
    if (this.tabs.length) {
      var perTab = this.tabs.map(function () { return 0; });
      this.rows.forEach(function (r) { var q = self.qty(r); if (q > 0 && r.tab >= 0 && r.tab < perTab.length) perTab[r.tab] += q; });
      var others = [];
      this.tabs.forEach(function (t, k) {
        var badge = $('[data-sk-qm-tab-count]', t);
        var nEl = $('[data-sk-qm-tab-n]', t);
        if (nEl) nEl.textContent = String(perTab[k]);
        if (badge) badge.hidden = perTab[k] === 0;
        t.classList.toggle('has-picks', perTab[k] > 0);
        if (k !== self.activeTab && perTab[k] > 0) others.push({ i: k, n: perTab[k], label: t.getAttribute('data-label') || '' });
      });
      if (this.elsewhere) {
        this.elsewhere.hidden = others.length === 0;
        if (others.length) {
          var html = '<span class="sk-plant-qm__elsewhere-label">' + esc(this.i18n.also || '') + '</span> ';
          html += others.map(function (o) {
            return '<button type="button" class="sk-plant-qm__elsewhere-btn" data-sk-qm-goto="' + o.i + '" aria-label="' +
              esc(fill(self.i18n.show_tab, { NAME: o.label })) + '">' + o.n + ' × ' + esc(o.label) + '</button>';
          }).join(' ');
          this.elsewhere.innerHTML = html;
        }
      }
    }
    var disc = this.discount(lines, count);

    var countEl = $('[data-sk-qm-count]', this.root);
    if (countEl) countEl.textContent = count > 0 ? this.pl('plants', count) : (this.i18n.none || this.pl('plants', 0));
    var sumEl = $('[data-sk-qm-sum]', this.root);
    if (sumEl) sumEl.classList.toggle('is-empty', count === 0);
    var sizesEl = $('[data-sk-qm-sizes]', this.root);
    if (sizesEl) sizesEl.textContent = lines.length ? ' · ' + this.pl('sizes', lines.length) : '';
    var mEl = $('[data-sk-qm-meters]', this.root);
    if (mEl) mEl.textContent = metersOk && count > 0 ? fill(this.i18n.meters, { M: this.num(meters) }) : '';
    var totalEl = $('[data-sk-qm-total]', this.root);
    if (totalEl) totalEl.textContent = this.money(total - disc.cents + addonCents);
    var dEl = $('[data-sk-qm-discount]', this.root);
    if (dEl) {
      dEl.hidden = disc.cents <= 0;
      if (disc.cents > 0) dEl.textContent = fill(this.i18n.discount_line, { PCT: String(disc.pct), AMOUNT: this.money(disc.cents) });
    }
    var tierState = $('[data-sk-qm-tier-state]', this.root);
    if (tierState) {
      var txt = '';
      if (disc.next && count > 0) txt = fill(this.i18n.tier_next, { PLANTS: this.pl('plants', disc.next.missing), PCT: String(disc.next.pct) });
      else if (disc.pct > 0) txt = fill(this.i18n.tier_top, { PCT: String(disc.pct) });
      tierState.textContent = txt || ' ';
      $$('[data-sk-qm-tier]', this.root).forEach(function (li) {
        li.classList.toggle('is-active', disc.pct > 0 && parseFloat(li.getAttribute('data-pct')) === disc.pct);
      });
    }
    if (announce) {
      var msg = this.pl('plants', count) + (lines.length ? ', ' + this.pl('sizes', lines.length) : '') + '. ' +
        (this.i18n.total || '') + ': ' + this.money(total - disc.cents + addonCents);
      window.clearTimeout(this.liveTimer);
      this.liveTimer = window.setTimeout(function () { self.say(msg); }, typing ? 900 : 450);
    }
    if (this.btnText) {
      this.btnText.textContent = count > 0 ? fill(this.i18n.add_count, { PLANTS: this.pl('plants', count) }) : (this.i18n.add || this.btnText.textContent);
    }
    this.lines = lines;
    this.count = count;
    // Frachtkasten/Pop-up (assets/sk-plant-freight.js): Auswahl mit Versandklasse je Zeile (pflanze.versandklasse)
    var freight = lines.map(function (l) { return { sku: l.sku, grams: l.grams, quantity: l.q, cls: l.ship }; });
    this.root.__skQmFreight = freight;
    try { this.root.dispatchEvent(new CustomEvent('sk-plant:qm-lines', { detail: { items: freight } })); } catch (e) { /* alter Browser */ }
    if (this.bar) {
      var bc = $('[data-sk-qm-bar-count]', this.bar);
      var bt = $('[data-sk-qm-bar-total]', this.bar);
      if (bc) bc.textContent = this.pl('plants', count);
      if (bt) bt.textContent = this.money(total - disc.cents + addonCents);
      this.toggleBar();
    }
  };

  Matrix.prototype.say = function (msg) {
    if (!this.liveEl) return;
    this.liveEl.textContent = '';
    var el = this.liveEl;
    window.setTimeout(function () { el.textContent = msg; }, 30);
  };

  Matrix.prototype.hideMessages = function () {
    if (this.errEl) this.errEl.hidden = true;
    if (this.okEl) this.okEl.hidden = true;
  };

  Matrix.prototype.showError = function (msg) {
    if (this.okEl) this.okEl.hidden = true;
    if (!this.errEl) return;
    this.errEl.textContent = msg;
    this.errEl.hidden = false;
  };

  Matrix.prototype.busy = function (on) {
    if (!this.btn) return;
    this.btn.disabled = on;
    this.btn.classList.toggle('is-busy', on);
    this.btn.setAttribute('aria-busy', on ? 'true' : 'false');
  };

  Matrix.prototype.submit = function (fromBar) {
    var self = this;
    this.update(false);
    this.hideMessages();
    function reveal() {
      if (fromBar && self.errEl) self.errEl.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    }
    if (!this.lines.length) {
      this.showError(this.i18n.empty);
      reveal();
      var first = null;
      this.rows.some(function (r) { if (r.input) { first = r.input; return true; } return false; });
      if (first) first.focus();
      return;
    }
    var items = this.lines.map(function (l) { return { id: Number(l.id), quantity: l.q }; });
    var addonId = this.addon && this.addon.checked ? Number(this.addon.value) : 0;
    if (addonId) items.push({ id: addonId, quantity: 1 });
    var summary = this.lines.map(function (l) { return l.q + ' × ' + l.size; });
    if (addonId) summary.push('1 × ' + (this.addon.getAttribute('data-title') || ''));
    var accOn = this.acc.filter(function (a) { return a.check && a.check.checked; });
    accOn.forEach(function (a) { items.push({ id: Number(a.id), quantity: a.n }); summary.push(a.n + ' × ' + a.title); });
    var added = this.lines.slice();
    this.busy(true);
    addItems(items).then(function () {
      self.busy(false);
      added.forEach(function (l) {
        var r = self.rowById(l.id);
        var mark = r && $('[data-sk-qm-added]', r.el);
        if (mark) { mark.textContent = '\u2713 ' + fill(self.i18n.row_added, { N: String(l.q) }); mark.hidden = false; }
      });
      self.rows.forEach(function (r) { self.setQty(r, 0); });
      if (self.addon) self.addon.checked = false;
      accOn.forEach(function (a) { a.check.checked = false; });
      self.update(false);
      var okText = fill(self.i18n.added, { ITEMS: summary.join(', ') });
      var t = $('[data-sk-qm-ok-text]', self.root);
      if (t) t.textContent = okText;
      if (self.okEl) self.okEl.hidden = false;
      self.say(okText);
      openDrawer();
    }).catch(function (err) {
      self.busy(false);
      self.showError(errorText(err, self.i18n));
      reveal();
    });
  };

  /* Heckenrechner → Zeile: Menge setzen (ersetzt den bisherigen Wert dieser Größe), hinscrollen, markieren */
  Matrix.prototype.take = function (id, n) {
    var row = this.rowById(id);
    if (!row || !row.input) return false;
    this.hideMessages();
    if (row.tab >= 0 && row.tab !== this.activeTab) this.activate(row.tab, false);
    if (row.el.classList.contains('is-extra')) {
      var more = $('[data-sk-qm-more]', this.root);
      if (more && more.getAttribute('aria-expanded') !== 'true') more.click();
    }
    // Heckenrechner-Aufklapper an der Größenliste bleibt offen; Zeile darunter wird markiert
    this.setQty(row, n, true);
    this.update(false);
    this.syncVariant(row.id);
    row.el.classList.remove('is-flash');
    void row.el.offsetWidth; // Animation neu starten
    row.el.classList.add('is-flash');
    row.el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    var self = this;
    window.setTimeout(function () {
      try { row.input.focus({ preventScroll: true }); } catch (e) { row.input.focus(); }
      self.say(fill(self.i18n.taken, { N: String(self.qty(row)), SIZE: row.size }));
    }, reduceMotion ? 0 : 450);
    return true;
  };

  /* ---------- Heckenrechner-Buttons übernehmen (Capture vor sk-xsell.js) ---------- */
  function hedgeMessage(form, text, isError) {
    var row = form.closest('[data-sk-hedge-row]') || form.parentNode;
    var el = row.querySelector('[data-sk-qm-hedge-msg]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'sk-plant-hedge__msg';
      el.setAttribute('data-sk-qm-hedge-msg', '');
      el.setAttribute('role', isError ? 'alert' : 'status');
      row.appendChild(el);
    }
    el.classList.toggle('is-error', !!isError);
    el.textContent = text;
    el.hidden = !text;
  }

  function initHedge(matrix) {
    var hedge = $('[data-sk-plant-hedge]');
    if (!hedge) return;
    var i18n = decodeAll(readJSON($('[data-sk-qm-hedge-i18n]', hedge))) ;
    if (!i18n.error_generic && matrix) i18n = matrix.i18n;
    // Label je nach Modus: mit Mengen-View „Übernehmen", sonst „In den Warenkorb"
    $$('[data-sk-hedge-add]', hedge).forEach(function (btn) {
      var lbl = btn.querySelector('span');
      var want = matrix ? btn.getAttribute('data-take-label') : btn.getAttribute('data-add-label');
      if (lbl && want && lbl.textContent !== want) lbl.textContent = want;
      if (matrix) btn.setAttribute('data-mode', 'take'); else btn.setAttribute('data-mode', 'add');
    });
    // Heckenrechner an der Größenliste (snippets/sk-plant-hedge-calc, mode 'buybox'): Button statt Formular
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-sk-hedge-take]');
      if (!b || !matrix) return;
      e.preventDefault();
      var hr = b.closest('[data-sk-hedge-row]');
      if (!hr) return;
      var n = parseInt(((hr.querySelector('[data-sk-hedge-count]') || {}).textContent || '').replace(/[^0-9]/g, ''), 10) || 1;
      matrix.take(hr.getAttribute('data-variant-id'), n);
    });
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.closest || !form.closest('[data-sk-plant-hedge]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var id = (form.querySelector('input[name="id"]') || {}).value;
      var n = parseInt((form.querySelector('input[name="quantity"]') || {}).value, 10) || 1;
      if (matrix && matrix.take(id, n)) return;
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      hedgeMessage(form, '', false);
      addItems([{ id: Number(id), quantity: n }]).then(function () {
        if (btn) btn.disabled = false;
        var hr = form.closest('[data-sk-hedge-row]');
        var label = n + ' × ' + ((hr && hr.getAttribute('data-title')) || '');
        if (!openDrawer()) hedgeMessage(form, fill(i18n.added || '', { ITEMS: label }), false);
      }).catch(function (err) {
        if (btn) btn.disabled = false;
        hedgeMessage(form, errorText(err, i18n), true);
      });
    }, true);
  }

  function init() {
    var matrix = null;
    $$('[data-sk-qm]').forEach(function (root, i) {
      var m = new Matrix(root);
      if (i === 0) matrix = m;
    });
    initHedge(matrix);
    // bfcache: vom Browser wiederhergestellte Mengen neu zusammenrechnen
    window.addEventListener('pageshow', function (e) { if (e.persisted && matrix) matrix.update(false); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
